/**
 * Builds the authentication portal URL with required parameters
 * @param src - Source identifier for logging purposes
 * @returns The complete authentication portal URL with encoded parameters
 *
 * @see {@link https://t.corp.amazon.com/67f1199b-d80c-4364-8ef6-4038beb0d775/communication#5ea1f594-2739-4f2c-aa3a-8191cc1dbf05 | Onboarding Documentation}
 * @example
 * // Example URL format:
 * // https://preprod.auth.warehousehiring.com/#/login?countryCode=IN&locale=en-IN&orgId=AMZN_WFS_LHRA&redirectUrl=https%3A%2F%2Fwatermelon-in.preprod.jobsatamazon.hvh.a2z.com%2Fapp%23%2Fauth-return&destinationUrl=https%3A%2F%2Fwatermelon-in.preprod.jobsatamazon.hvh.a2z.com&referrer=PHO
 */
export function buildAuthPortalURL(src: string, baseAuthPortalURL: string) {
  const urlParams = new URLSearchParams(window.location.search);

  // Temporary log for the issue with the auth portal URL
  console.log(`Redirecting to auth portal from ${src}`, urlParams, JSON.stringify(window.location.href));
  urlParams.forEach((value, key) => {
    console.log(`${key}: ${value}`);
  });

  const referrer = urlParams.get('referrer') || window.location.href;
  const locale = urlParams.get('locale')?.replace('_', '-') || 'en-IN';
  const orgId = urlParams.get('login_hint')?.split(':')[3] || '';

  const authPortalURL = `${baseAuthPortalURL}?countryCode=IN&locale=${locale}&orgId=${orgId}&redirectUrl=${encodeURIComponent(referrer + '/app#/auth-return')}&destinationUrl=${encodeURIComponent(referrer)}&referrer=PHO`;

  // Temporary log for the issue with the auth portal URL
  console.log(`Final url to auth portal from ${src}`, JSON.stringify(authPortalURL));

  return authPortalURL;
}
